import type { EmbedLineRef } from './parseEmbedLine.ts'
import styles from './ArticleEmbed.module.css'

const LABELS: Record<EmbedLineRef['kind'], string> = {
  match: 'Match card',
  player: 'Player card',
  trust: 'Trust Score card',
}

/** Stands in for an embed in an editor preview, before the article is saved. */
export function EmbedPlaceholder({ embedRef }: { embedRef: EmbedLineRef }) {
  return (
    <div className={[styles.embed, styles.placeholder].join(' ')}>
      <span className={styles.label}>{LABELS[embedRef.kind]}</span>
      <span className={styles.handle}>{embedRef.key}</span>
      <span className={styles.hint}>Shows live data once published</span>
    </div>
  )
}
